import { FC } from 'react';

import { truncateString } from '@/utils/functions';
import styles from './MemoWarning.module.css';
import { Icon } from '../../Icon';
import { Button, CopyButton } from '../../buttons';

interface MemoWarningProps {
  coinName?: string;
  memoValue?: string;
  onCopyClick?: () => void;
  isBuyFlowWarning?: boolean;
  onExitClick?: () => void;
}
export const MemoWarning: FC<MemoWarningProps> = ({
  coinName,
  memoValue,
  onCopyClick,
  isBuyFlowWarning = false,
  onExitClick,
}) => {
  return isBuyFlowWarning ? (
    <div className={styles.container}>
      <Icon name="notifications" className={styles.icon} />
      <h3 className={styles.title}>
        <p className={styles.memoTitle}>
          Important: {coinName || ''} transactions with incorrect or missing MEMO for your receiving address will be
          lost and cannot be recovered.
        </p>
        Please check your wallet or exchange.
      </h3>
      <Button onPress={onExitClick}>I understand</Button>
    </div>
  ) : (
    <div className={styles.container}>
      <Icon name="notifications" className={styles.icon} />
      <h3 className={styles.title}>
        <p className={styles.memoTitle}>
          Important: {coinName || ''} transactions without a memo will be lost and cannot be recovered.
        </p>
        Please ensure you include RelayPay&apos;s Memo ID on your sending wallet or exchange. Memo can be found under
        the wallet address, and below.
      </h3>
      <div className={styles.memoWrapper}>
        <span className={styles.checkoutDataTitle}>Memo:</span>
        <CopyButton
          className={styles.copyButton}
          iconClassName={styles.copyIcon}
          variants="memo"
          iconPosition="right"
          valueForCopy={memoValue || ''}
          onCopyClick={onCopyClick}
        >
          {truncateString({ string: memoValue || '' })}
        </CopyButton>
      </div>
    </div>
  );
};
